export default __webpack_public_path__ + "static/media/1568.a1ea557c.png";